import { ComponentProps, memo, forwardRef } from 'react';
import { StepperElement } from './StepperElement';

export type StepperPreviewProps = Omit<
  ComponentProps<typeof StepperElement>,
  'isCollapsed'
>;

export const StepperPreview = memo(
  forwardRef<HTMLDivElement, StepperPreviewProps>((props, ref) => (
    <StepperElement {...props} ref={ref} isCollapsed />
  )),
);

StepperPreview.displayName = 'StepperPreview';
